//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[["numInstances"],"GetServerNames",{R_:{names:""}},0,1],[["names"],"SetServerNames",{},1,1],[["serverName","numTags"],"GetServerTagsV2",{R_:{tagInfos:""}},1,0],[["serverName","tagInfos"],"SetServerTagsV2",{},2,0],[["numServers"],"GetServers",{R_:{serverInfos:""}},0,0],[["serverInfos"],"SetServers",{},1,0]],[]];
SPLM.Mechatronics.OPCUAClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.OPCUAClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.OPCUAClientBuilder.TagInfo = class{
    constructor(name,eIOType,eDataType){
        this.name=name;this.eIOType=eIOType;this.eDataType=eDataType;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
};

SPLM.Mechatronics.OPCUAClientBuilder.TagInfoV2 = class{
    constructor(name,eIOType,strDataTypeName){
        this.name=name;this.eIOType=eIOType;this.strDataTypeName=strDataTypeName;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Strdatatypename(){return this.strDataTypeName}
    set Strdatatypename(val){this.strDataTypeName = val}
};

SPLM.Mechatronics.OPCUAClientBuilder.ServerInfo = class{
    constructor(url,endPoint,updateTime,connectionType,messageSecurityMode,securityPolicy,userName,certificateFile,privateKeyFile){
        this.url=url;this.endPoint=endPoint;this.updateTime=updateTime;this.connectionType=connectionType;this.messageSecurityMode=messageSecurityMode;this.securityPolicy=securityPolicy;this.userName=userName;this.certificateFile=certificateFile;this.privateKeyFile=privateKeyFile;}
    get Url(){return this.url}
    set Url(val){this.url = val}
    get Endpoint(){return this.endPoint}
    set Endpoint(val){this.endPoint = val}
    get Updatetime(){return this.updateTime}
    set Updatetime(val){this.updateTime = val}
    get Connectiontype(){return this.connectionType}
    set Connectiontype(val){this.connectionType = val}
    get Messagesecuritymode(){return this.messageSecurityMode}
    set Messagesecuritymode(val){this.messageSecurityMode = val}
    get Securitypolicy(){return this.securityPolicy}
    set Securitypolicy(val){this.securityPolicy = val}
    get Username(){return this.userName}
    set Username(val){this.userName = val}
    get Certificatefile(){return this.certificateFile}
    set Certificatefile(val){this.certificateFile = val}
    get Privatekeyfile(){return this.privateKeyFile}
    set Privatekeyfile(val){this.privateKeyFile = val}
};

export default SPLM;